import { RehydrationContext } from "../utils/rehydration";

/**
 * Context provider component for hydration of media query configuration.
 */
const MatchMediaHydrationProvider = RehydrationContext.Provider;

export default MatchMediaHydrationProvider;
